import http from "./base";

import store from "@/store";

export default function httpSetup() {
  return http(store);
}
